module.exports = __webpack_public_path__ + "static/media/agente_chat.61566fd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/SupervisorChat/agente_chat.svg
// module id = 1833
// module chunks = 0